export const messages = {
  en: {
    assetInventoryInStock: {
      title: 'Inventory Information',
      print: 'Print',
      back: 'Back',
      inventoryName: 'Inventory Name',
      inventoryPerson: 'Inventory Person',
      warehouse: 'Warehouse',
      inventoryDate: 'Inventory Date',
      remark: 'Remark',
      status: 'Status',
      inventoryItems: 'Inventory Items',
      warehouseName: 'Warehouse Name',
      itemType: 'Item Type',
      itemName: 'Item Name',
      specification: 'Specification',
      itemCode: 'Item Code',
      isFixedItem: 'Is Fixed Item',
      batchPrice: 'Batch Price',
      originalStock: 'Original Stock',
      inventoryQuantity: 'Inventory Quantity',
      auditInfo: 'Audit Information',
      auditor: 'Auditor',
      contactNumber: 'Contact Number',
      auditTime: 'Audit Time',
      auditOpinion: 'Audit Opinion'
    }
  },
  zh: {
    assetInventoryInStock: {
      title: '盘点信息',
      print: '打印',
      back: '返回',
      inventoryName: '盘点名称',
      inventoryPerson: '盘点人',
      warehouse: '选择仓库',
      inventoryDate: '盘点日期',
      remark: '盘点说明',
      status: '审核状态',
      inventoryItems: '盘点商品',
      warehouseName: '仓库名称',
      itemType: '物品类型',
      itemName: '物品名称',
      specification: '物品规格',
      itemCode: '物品编码',
      isFixedItem: '是否是固定物品',
      batchPrice: '批次价格',
      originalStock: '原有库存',
      inventoryQuantity: '盘点后数量',
      auditInfo: '审核信息',
      auditor: '审核人',
      contactNumber: '联系电话',
      auditTime: '审核时间',
auditOpinion: '审核意见'
    }
  },
  'zh-TW': {
    assetInventoryInStock: {
      title: '盤點信息',
      print: '列印',
      back: '返回',
      inventoryName: '盤點名稱',
      inventoryPerson: '盤點人',
      warehouse: '選擇倉庫',
      inventoryDate: '盤點日期',
      remark: '盤點說明',
      status: '審核狀態',
      inventoryItems: '盤點商品',
      warehouseName: '倉庫名稱',
      itemType: '物品類型',
      itemName: '物品名稱',
      specification: '物品規格',
      itemCode: '物品編碼',
      isFixedItem: '是否是固定物品',
      batchPrice: '批次價格',
      originalStock: '原有庫存',
      inventoryQuantity: '盤點後數量',
      auditInfo: '審核信息',
      auditor: '審核人',
      contactNumber: '聯繫電話',
      auditTime: '審核時間',
      auditOpinion: '審核意見'
    }
  }
}